var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Polygon_1","data-name":"Polygon 1","d":"M8,0l2,5.95,6,.161L11.236,9.95,12.944,16,8,12.422,3.056,16,4.764,9.95,0,6.111,6,5.95Z","fill":"#C29A5C"}));
}

Star.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Star;

Star.default = Star;
